
import { Infraction } from './infraction.entity';

export class InfractionDto extends Infraction {

}
